document.addEventListener("DOMContentLoaded", function () {
    const menu__button = document.getElementById("menu__button");
    if (menu__button) {
        menu__button.addEventListener("click", function () {
            const header = document.getElementById("header");
            if (header) {
                header.classList.toggle("menu--active");
            }
        });
    }
    const close__button = document.getElementById(
        "header__menu__mobile--close"
    );
    if (close__button) {
        close__button.addEventListener("click", function () {
            const header = document.getElementById("header");
            if (header) {
                header.classList.toggle("menu--active");
            }
        });
    }
});
